<template>
    <div class="card chart-card">
        <div class="card-head">
            <div class="card-head-text">
                <div class="card-title">{{ payload.title }}</div>
                <div v-if="payload.subtitle" class="card-sub">{{ payload.subtitle }}</div>
            </div>
            <div class="card-head-actions">
                <button
                    type="button"
                    class="chart-expand-btn"
                    title="Открыть график"
                    @click="expandOpen = true"
                >
                    <ChatIcon name="maximize" :size="15" />
                    <span>График</span>
                </button>
            </div>
        </div>

        <ChartLegendPanel
            :items="legendItems"
            compact
            @toggle="onLegendToggle"
        />

        <CompareChartView
            :payload="payload"
            :view-config="localView"
            :max-tooltip-rows="6"
        />

        <ChatChartExpandModal
            :open="expandOpen"
            :payload="payload"
            :view-config="localView"
            :title="payload.title"
            :subtitle="payload.subtitle"
            @close="expandOpen = false"
            @update:view-config="patchView"
        />
    </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import ChatIcon from '@/components/chat/icons/ChatIcon.vue'
import CompareChartView from './CompareChartView.vue'
import ChartLegendPanel from './ChartLegendPanel.vue'
import ChatChartExpandModal from './ChatChartExpandModal.vue'
import {
    buildLegendItems,
    defaultChartViewConfig,
    normalizeChartViewConfig,
    toggleLegendKey,
} from './chartViewConfig'

const props = defineProps({
    payload: { type: Object, required: true },
    viewConfig: { type: Object, default: null },
})

const emit = defineEmits(['update:view-config'])

const expandOpen = ref(false)
const localView = ref(normalizeChartViewConfig(props.viewConfig || defaultChartViewConfig()))

watch(
    () => props.viewConfig,
    v => {
        localView.value = normalizeChartViewConfig(v || defaultChartViewConfig())
    },
    { deep: true },
)

const legendItems = computed(() =>
    buildLegendItems(props.payload, localView.value),
)

function patchView(next) {
    localView.value = normalizeChartViewConfig(next)
    emit('update:view-config', { ...localView.value })
}

function onLegendToggle(key) {
    patchView(toggleLegendKey(props.payload, localView.value, key))
}
</script>

<style scoped>
.card {
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 12px;
    padding: 18px 20px;
    margin: 12px 0;
}

.card-head {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 10px;
    gap: 12px;
    flex-wrap: wrap;
}

.card-head-text {
    flex: 1;
    min-width: 200px;
}

.card-title {
    font-size: 14px;
    font-weight: 700;
    color: #23282C;
}

.card-sub {
    font-size: 11px;
    color: #888888;
    margin-top: 4px;
}

.chart-expand-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 10px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background: #f7f7f7;
    font-size: 11.5px;
    font-weight: 600;
    color: #5f5f5f;
    cursor: pointer;
}

.chart-expand-btn:hover {
    border-color: #c0c0c0;
    color: #23282C;
    background: #f0f0f0;
}
</style>
